import React from "react";
import { useSelector } from "react-redux";



export default function CouponTable({ coupons, onEditCoupon }) {
  const sidebar = useSelector(state => state.sidebar);

  return (
    <div className="verificationTableContainer">
      <div className="verificationTableRow">
        <div
          style={{ width: "8%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Sr. No.
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Coupon Code
        </div>
        <div
          style={{ width: "15%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Description
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Min Value
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Discount Type
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Discount Value
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Valid From
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Valid Until
        </div>
        <div
          style={{ width: "5%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Status
        </div>
      </div>
      {coupons.map((coupon, index) => (
        <div
          key={coupon.id}
          className="verificationTableRow"
          style={{
            backgroundColor: index % 2 === 0 ? "#6b5acd0e" : "#6b5acd1d",
          }}
        >
          <div
            style={{ width: "8%", height: "100%" }}
            className="eachColumn eachTableBody"
          >
            {index + 1}
          </div>
          <div
            style={{ 
              width: "12%", 
              height: "100%",
              cursor: "pointer",
              color: "#3366CC",
              textDecoration: "underline"
            }}
            className="eachColumn eachTableBody"
            onClick={() => onEditCoupon(coupon)}
          >
            {coupon.name}
          </div>
          <div
            style={{ width: "15%", height: "100%" }}
            className="eachColumn eachTableBody"
          >
            {coupon.description}
          </div>
          <div
            style={{ width: "12%", height: "100%" }}
            className="eachColumn eachTableBody"
          >
            {coupon.minProjectValue} SAR
          </div>
          <div
            style={{ width: "12%", height: "100%" }}
            className="eachColumn eachTableBody"
          >
            {coupon.offValidation.condition}
          </div>
          <div
            style={{ width: "12%", height: "100%" }}
            className="eachColumn eachTableBody"
          >
            {coupon.offValidation.value} {coupon.offValidation.condition === "PERCENTAGE" ? "%" : "SAR"}
          </div>
          <div
            style={{ width: "12%", height: "100%" }}
            className="eachColumn eachTableBody"
          >
            {coupon.validity?.from?.toDate ? 
              new Date(coupon.validity.from.toDate()).toLocaleDateString() : 
              'N/A'}
          </div>
          <div
            style={{ width: "12%", height: "100%" }}
            className="eachColumn eachTableBody"
          >
            {coupon.validity?.to?.toDate ? 
              new Date(coupon.validity.to.toDate()).toLocaleDateString() : 
              'N/A'}
          </div>
          <div
            style={{ width: "5%", height: "100%" }}
            className="eachColumn eachTableBody"
          >
            <span
              style={{
                color: coupon.status === "ACTIVE" ? "#10B981" : "#EF4444",
              }}
            >
              {coupon.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}